module.exports = __webpack_public_path__ + "static/media/handbook.438acdba.jpg";